import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import TableSort from "../../../../../shared/helpers/table-sort";
import DisplayLocationTableComponent from "./display-location-table.component";
import { getAllDisplayLocations } from "src/core/api/services/display-location.service";

const DisplayLocationLocation = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [displayLocationSearchValue, setDisplayLocationSearchValue] =
    useState("");
  const pageSize = 10;
  const [SortBy, setSortBy] = useState<any>("Name");
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Location Name",
      label: "name",
      isSorted: true,
    },
  ]);

  const {
    data: displayLocations,
    isLoading: isLoadingDisplayLocations,
    refetch,
  } = useQuery({
    queryKey: [
      "getAllDisplayLocations",
      PageNumber,
      SortBy,
      SortDirection,
      displayLocationSearchValue,
    ],
    queryFn: ({ signal }) =>
      getAllDisplayLocations(
        PageNumber,
        pageSize,
        signal,
        SortBy,
        SortDirection,
        displayLocationSearchValue
      ),
  });

  const onRefetchData = () => {
    if (displayLocations?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setDisplayLocationSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <DisplayLocationTableComponent
        columns={columns}
        data={displayLocations?.data}
        totalNumberOfRecords={displayLocations?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingDisplayLocations}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default DisplayLocationLocation;
